common.View.create('crud::form.inputs.Rangeslider', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initGui();
    },

    /**
     * Initializes the GUI.
     */
    initGui() {

        // Init (default) options.
        let options = {
            onChange: this.onChange.bind(this),
            min: 0,
            max: 12,
            step: 1,
            type: 'double',
            from: 1,
            to: 12,
            ...this.element.data('options'),
        };

        // Init the rangeslider.
        this.element.find('input[name=""]')
                    .ionRangeSlider(options);
    },

    onChange(event)
    {
        // TODO
        this.updateHiddenInputs(event);
    },

    updateHiddenInputs(event)
    {
        // Loop hidden inputs.
        _.each($('input:not([name=""])', this.element), (input, index) =>
        {
            // Set value?
            if(event)
                $(input).val(event[index == 0 ? 'from' : 'to']);

            // Clear value?
            else
                $(input).val('');
        });
    }

});
